export default __webpack_public_path__ + "static/media/teams.783f01c3.svg";